import axios from 'axios'
import { decode } from 'jsog'

const toData = response => decode(response.data)

export function getCollaborators(): Promise {
  return axios.get('/bw/collaborator/').then(toData)
}

export function getCollaboratorsByUnit(id): Promise {
  return axios.get(`/bw/collaborator/unit/${id}`).then(toData)
}

export function getCollaborator(id): Promise {
  return axios.get(`/bw/collaborator/${id}`).then(toData)
}

export function deleteCollaborator(id): Promise {
  return axios.delete(`bw/collaborator/${id}`)
}

export function exportCollaborator(): Promise {
  return axios.get('bw/collaborator/export', {
    headers: {
      Accept:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    },
    responseType: 'arraybuffer'
  })
}

export function importCollaborators(data): Promise {
  return axios.post(`bw/collaborator/import`, data).then(toData)
}

export function upsertCollaborator(data): Promise {
  return axios.post(`bw/collaborator/`, data)
  
}




// WEBPACK FOOTER //
// ./src/services/collaborator-service.js